import { Component, type ReactNode } from 'react';

/**
 * Aísla el fallo de una herramienta (DLC): si su componente lanza un error, se
 * muestra este aviso en su lugar y el resto del panel sigue funcionando.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode; fallback?: ReactNode },
  { error: Error | null }
> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div className="ld-card" style={{ borderColor: '#e5484d' }}>
            <p style={{ margin: 0, color: '#e5484d', fontSize: 13 }}>
              Esta herramienta ha fallado y se ha aislado para no afectar al resto del panel.
            </p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
